export default {"src":"/encomendas-static/_next/static/media/icon-trash.e5c2f4d7.svg","height":24,"width":20,"blurWidth":0,"blurHeight":0};